import {
    TableViewStore,
    BaseListViewStore,
    QueryPickerStore,
    BaasicDropdownStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { PatientService } from 'application/patient/services';
import { FacilityService } from "application/facility/services";
import _ from 'lodash';
import { action } from 'mobx';

@applicationContext
class PatientViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new PatientService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'patient',
            autoInit: true,
            routes: {
                preview: item => {
                    this.setChildNavigationTitle(i => i.brightreeID === item.brightreeID, () => item.firstName + ' ' + item.lastName);
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.patient.preview.general',
                        { id: item.brightreeID, firstName: item.firstName, lastName: item.lastName }
                    )
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({ ...params, search: params.search && '*' + params.search + '*' });
                        _.extend(response.data,
                            {
                                item: _.map(response.data.item, (item => {
                                    return _.extend(
                                        item, {
                                        DeliveryStreet: item.deliveryAddress.addressLine1
                                    }
                                    );
                                }))
                            });
                        return response.data;
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'lastName',
                    title: 'PATIENT.LIST.COLUMNS.LAST_NAME',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'firstName',
                    title: 'PATIENT.LIST.COLUMNS.FIRST_NAME',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'DeliveryStreet',
                    title: 'PATIENT.LIST.COLUMNS.FACILITY'
                }
            ]
        }));

        this.queryUtility.onResetFilter = () => {
            this.queryPickerStore.reset();
            this.facilityStore.setValue(null);
            this.facilityStore.filterTerm = "";
        }
        this.queryPickerStore = new QueryPickerStore();

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        },
            {
                fetchFunc: async (term) => {
                    const response = await facilityService.find({ searchQuery: term, rpp: 100 });
                    return _.map(response.data.item, item => {
                        return {
                            id: item.id,
                            name: item.name
                        };
                    });
                }
            });
    }

    @action.bound
    filterOnChange() {
        this.queryUtility.fetch();
    }
}

export default PatientViewStore;
